document.addEventListener("DOMContentLoaded", function () {
  const checkboxes = document.querySelectorAll(".fbt-checkbox");
  const items = document.querySelectorAll(".fbt-item");
  const totalEl = document.getElementById("fbt-total-price");
  const addToCartBtn = document.querySelector(".fbt-add-to-cart");

  function updateTotal() {
    let total = 0;
    items.forEach((item, index) => {
      const checkbox = item.querySelector(".fbt-checkbox");
      const price = parseFloat(item.dataset.price);
      if (checkbox.checked) {
        total += price;
      }
    });
    totalEl.innerText = "$" + total.toFixed(2);
  }

  checkboxes.forEach((cb) => cb.addEventListener("change", updateTotal));
  updateTotal();

  addToCartBtn.addEventListener("click", () => {
    const formData = {
      items: [],
    };

    items.forEach((item) => {
      const checkbox = item.querySelector(".fbt-checkbox");
      const variantId = item.dataset.variantId;

      if (checkbox.checked) {
        formData.items.push({
          id: variantId,
          quantity: 1,
        });
      }
    });

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    }).then((res) => {
      if (res.ok) {
        window.location.href = "/cart";
      }
    });
  });
});
